import { render, staticRenderFns } from "./site-footer.vue?vue&type=template&id=6e68cc44&lang=pug&"
import script from "./site-footer.vue?vue&type=script&lang=js&"
export * from "./site-footer.vue?vue&type=script&lang=js&"
import style0 from "./site-footer.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports